import type { RolePayload, RoleResponse } from '@/types/apps/role.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type RoleListResponse = ApiResponse<PaginatedResult<RoleResponse>>;

export class RoleService implements Creatable, Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/roles',
        delete: () => '/api/roles/delete-role',
        detail: (id: string) => `/api/roles/${id}`,
    };

    public index(params?: QueryParams): Promise<RoleListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public create(
        payload: RolePayload
    ): Promise<ApiResponse<RoleListResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: RolePayload
    ): Promise<ApiResponse<RoleListResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.delete();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
